export default __webpack_public_path__ + "static/landscapeImagePlaceholder-cb6d6ebb002e42781be0dcb49646f506.png";